/** The file was automatically generated. Please do not modify manually */
import pt from './online.json';
export var strings_pt = pt;
